var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"spinner spinner--plane",style:(_vm.styles)},[_c('div',{staticClass:"spinner-inner",style:(_vm.innerStyles)},[_vm._m(0),_vm._m(1),_vm._m(2)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mask",attrs:{"id":"top"}},[_c('div',{staticClass:"plane"})])
},function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mask",attrs:{"id":"middle"}},[_c('div',{staticClass:"plane"})])
},function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mask",attrs:{"id":"bottom"}},[_c('div',{staticClass:"plane"})])
}]

export { render, staticRenderFns }